import apiClient, { getApiErrorMessage } from "./apiClient";

function unwrapResponse(response) {
    return response?.data?.data ?? response?.data;
}

export async function apiLogin(email, password) {
    try {
        const response = await apiClient.post("/auth/login", { email, password });
        return unwrapResponse(response);
    } catch (error) {
        throw new Error(getApiErrorMessage(error, "Correo o contrasena incorrectos."));
    }
}

export async function apiLogout() {
    try {
        await apiClient.post("/auth/logout");
    } catch (error) {
        // El cierre local de sesion debe continuar aunque falle la API.
    }
}

export async function fetchCurrentUser() {
    const response = await apiClient.get("/auth/me");
    return unwrapResponse(response);
}

export async function fetchUsers() {
    const response = await apiClient.get("/users");
    return unwrapResponse(response) || [];
}

export async function createUser(payload) {
    const response = await apiClient.post("/users", payload);
    return unwrapResponse(response);
}

export async function updateUser(uid, payload) {
    const response = await apiClient.put(`/users/${uid}`, payload);
    return unwrapResponse(response);
}

export async function deleteUser(uid) {
    const response = await apiClient.delete(`/users/${uid}`);
    return unwrapResponse(response);
}

export async function findUserByName(nombre) {
    const response = await apiClient.get("/users/by-name", {
        params: { nombre },
    });
    return unwrapResponse(response);
}

export async function fetchInfracciones(params = {}) {
    const response = await apiClient.get("/infracciones", {
        params: {
            ...params,
            _t: Date.now()
        },
    });
    return unwrapResponse(response) || [];
}

export async function createInfraccion(payload) {
    const response = await apiClient.post("/infracciones", payload);
    return unwrapResponse(response);
}

export async function updateInfraccion(id, payload) {
    const response = await apiClient.put(`/infracciones/${id}`, payload);
    return unwrapResponse(response);
}

export async function softDeleteInfraccion(id, motivo) {
    const response = await apiClient.patch(`/infracciones/${id}/delete`, { motivo });
    return unwrapResponse(response);
}

export async function uploadInfraccionPhoto(file, type, folder = "infracciones") {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    formData.append("folder", folder);

    const response = await apiClient.post("/uploads/infracciones", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

    const data = unwrapResponse(response);
    return data?.url || data?.publicUrl || "";
}
